import { api } from "../api";
import type { PaginatedResponse } from "../../types/domain";
import type { Center } from "../../types/domain";
import type { TrialCenterItem, TrialUpdate } from "../../types/trial";

export const trialService = {
  listTrialCenters: (params?: {
    status_filter?: string;
    skip?: number;
    limit?: number;
  }) => {
    const query = new URLSearchParams();
    if (params?.status_filter) query.set("status_filter", params.status_filter);
    if (params?.skip !== undefined) query.set("skip", String(params.skip));
    if (params?.limit !== undefined) query.set("limit", String(params.limit));
    const qs = query.toString();
    return api.get<PaginatedResponse<TrialCenterItem>>(
      `/trial-centers${qs ? `?${qs}` : ""}`
    );
  },

  updateCenterTrial: (centerId: string, update: TrialUpdate) =>
    api.patch<Center>(`/trial-centers/${centerId}/trial`, update),

  extendCenterTrial: (centerId: string, days: number) =>
    api.post<Center>(`/trial-centers/${centerId}/trial/extend?days=${days}`),
};
